import { useLoginDetail } from "@/queries";
import { LuCalendar } from "react-icons/lu";
import { getCurrentProgramYear } from "@/utils/dates";

const DashboardHeading = () => {
  const loginDetail = useLoginDetail();

  const hour = new Date().getHours();
  const greeting =
    hour < 12 ? "Good morning" : hour < 17 ? "Good afternoon" : "Good evening";

  const today = new Date().toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div className="mt-3 pb-5">
      <h1>
        {greeting}, {loginDetail.firstName} {loginDetail.lastName}
      </h1>
      <div
        className="d-flex align-items-center gap-3 mt-2"
        style={{ fontSize: "1rem" }}
      >
        <span
          style={{ fontWeight: 500 }}
          className="d-flex align-items-center gap-1"
        >
          <LuCalendar size={15} />
          Academic Year: {getCurrentProgramYear()}
        </span>
        <span>|</span>
        <span style={{ fontWeight: 500 }}>{today}</span>
      </div>
    </div>
  );
};

export default DashboardHeading;
